import { PublisherRegistrationIntentEnum, } from "../types/Api";
/**
 * Returns the publisher's active registrations, i.e. registrations
 * that have not been terminated (terminationTime is null/undefined).
 */
export var getActiveRegistrations = function (publisher) {
    var _a;
    return ((_a = publisher === null || publisher === void 0 ? void 0 : publisher.registrations) !== null && _a !== void 0 ? _a : []).filter(function (registration) { return !registration.terminationTime; });
};
/**
 * Returns the publisher's active registration at the given agency
 * (ISBN/ISMN), or undefined when the publisher has none.
 */
export var getActiveRegistrationForAgency = function (publisher, agency) {
    return agency
        ? getActiveRegistrations(publisher).find(function (registration) {
            return String(registration.registrationAgency) === String(agency);
        })
        : undefined;
};
/**
 * Returns true when the publisher's active registration at the given
 * agency (ISBN/ISMN) has the ONE_OFF registration intent.
 */
export var hasActiveOneOffRegistration = function (publisher, agency) {
    var _a;
    return ((_a = getActiveRegistrationForAgency(publisher, agency)) === null || _a === void 0 ? void 0 : _a.registrationIntent) ===
        PublisherRegistrationIntentEnum.ONE_OFF;
};
/**
 * Returns true when the publisher has any active registration with the
 * ONE_OFF intent, regardless of the agency. Mirrors the backend
 * `Publisher.findActiveOneOffRegistration()`.
 */
export var hasAnyActiveOneOffRegistration = function (publisher) {
    return getActiveRegistrations(publisher).some(function (registration) {
        return registration.registrationIntent ===
            PublisherRegistrationIntentEnum.ONE_OFF;
    });
};
